/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Children, useCallback, useRef, useState } from 'react';
import { EditorState, Modifier } from 'draft-js';
import { useActions, useModalActions } from '../../provider';
import { findLinkRange } from '../../helpers';
import { modalNames } from '../../config';
import PopoverContent from './PopoverContent';
import styles from './index.module.scss';

const Link = ({ contentState, entityKey, children }) => {
  const { getEditorState, onChange } = useActions();
  const { open } = useModalActions();

  const { url } = contentState.getEntity(entityKey).getData();

  const [popoverVisible, setPopoverVisible] = useState(false);

  const closePopover = useCallback(() => setPopoverVisible(false), []);

  const handleDelete = () => {
    onChange(removeLinkFromText(getEditorState()));
  };

  const handleEdit = () => {
    const text = Children.map(children, (child) => child.props.text).join('');

    open(...getModalData(url, text));
    closePopover();
  };

  const handleLinkClick = (e) => {
    e.preventDefault();

    if (!popoverVisible) {
      setPopoverVisible(true);
    }
  };

  const rootRef = useRef();

  return (
    <div
      className={styles.root}
      ref={rootRef}
    >
      <a
        href="#"
        onClick={handleLinkClick}
      >
        {children}
      </a>
      {popoverVisible && (
        <PopoverContent
          url={url}
          onEditBtnClick={handleEdit}
          onDeleteBtnClick={handleDelete}
          onClose={closePopover}
          parentRef={rootRef}
        />
      )}
    </div>
  );
};

export default Link;

function getModalData(url, text) {
  const data = { text, editMode: true };

  if (url.startsWith('tel:')) {
    return [
      modalNames.phone,
      {
        ...data,
        phone: url.includes('p')
          ? url.slice(4, url.indexOf('p'))
          : url.slice(4),
        dopPhone: url.includes('p') ? url.slice(url.indexOf('p') + 1) : '',
      },
    ];
  }

  return [modalNames.link, { ...data, url }];
}

function removeLinkFromText(state) {
  const selection = state.getSelection();
  const currentContent = state.getCurrentContent();

  const block = currentContent.getBlockForKey(selection.getStartKey());

  const linkRange = findLinkRange(block, currentContent, selection);

  if (linkRange) {
    const contentWithoutLink = Modifier.applyEntity(
      currentContent,
      linkRange,
      null
    );

    return EditorState.set(state, { currentContent: contentWithoutLink });
  }

  return state;
}
